export default __webpack_public_path__ + "static/placeholder-72188b0a85af2a71e73804f753296041.svg";